import { render, staticRenderFns } from "./PrepaidGroup.vue?vue&type=template&id=2ea40a3b&"
import script from "./PrepaidGroup.vue?vue&type=script&lang=js&"
export * from "./PrepaidGroup.vue?vue&type=script&lang=js&"
import style0 from "./PrepaidGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports